import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './mdhub';
import Sentry from './monitoring/sentry';

Sentry.init()

ReactDOM.render(<App key={Date.now()} />, document.getElementById('root'));

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  require('./setupDev.tsx');
}
